export 	const formatMonthLabel = (quantity:number):string => {
    return quantity === 1 ? 'miesiąc' : quantity >= 5 && quantity <= 21
    ? 'miesięcy'
    : quantity % 10 === 2 ||
      quantity % 10 === 3 ||
      quantity % 10 === 4
    ? 'miesiące'
    : 'miesięcy';
}